import React, {lazy, Suspense} from 'react'
import t from 'format-message'
import {useLocation, useParams} from 'react-router'
import {useDocumentTitle} from '../../../../common/lib/useDocumentTitle'

const Preview = lazy(() => import('./index').then(({Preview}) => ({default: Preview})))

export function PreviewPage() {
  const {activeAssignmentId} = useParams()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)

  useDocumentTitle(t('Preview'))

  return (
    <Suspense>
      <Preview
        activeAssignmentId={activeAssignmentId}
        printOnLoad={searchParams.get('printOnLoad') === '1'}
      />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the preview module.
 */
export const previewRoutes = [
  {
    index: true,
    element: <PreviewPage />,
  },
]
